import { useRegion } from "./useRegion.js";
//#region src/modules/Regions/hooks/useRegionTimezone.ts
/**
* Resolves a region's IANA timezone by id, via the existing cached
* region-profile hook — a remount for a regionId already resolved elsewhere
* hits the RPC client's warm cache instead of firing again. Schedules
* (RRULEs) are interpreted in the scope region's timezone at generation
* time, so any screen displaying or authoring a wall-clock RRULE needs this
* to label the time correctly.
*/
function useRegionTimezone(regionId) {
	const { data } = useRegion(regionId ? { regionId } : void 0, { cacheStrategy: "cache-only" });
	return data?.region?.timezone;
}
//#endregion
export { useRegionTimezone };

//# sourceMappingURL=useRegionTimezone.js.map